import { ReactNode } from 'react';
import {
	TextField as TextFieldMui,
} from '@mui/material';
import { InputProps, appendClassName } from '@componentLibraryWrapper/common';
import './textfield.scss';

export interface TextFieldProps extends InputProps<HTMLTextAreaElement | HTMLInputElement, HTMLDivElement> {
	defaultValue?: any,
	error?: boolean,
	helperText?: ReactNode,
	inputProps?: TextFieldInputProps
}

export type TextFieldInputProps = {
	minLength?: number,
	maxLength?: number
}

const TextField = ({
	className,
	inputProps,
	...rest
}: TextFieldProps) => {
	return (
		<TextFieldMui
			{...rest}
			inputProps={inputProps}
			className={appendClassName('sm-textfield', className)}/>
	)
}

export default TextField;